import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { subscribeApiStatus } from "@/lib/api";

/**
 * Slim top banner that appears whenever the axios layer is retrying a request
 * (e.g. during a deploy warmup 502/503/504 or a transient network error).
 * Hides itself automatically once a request succeeds.
 */
export default function ApiStatusBanner() {
  const [retrying, setRetrying] = useState(false);

  useEffect(() => subscribeApiStatus(setRetrying), []);

  if (!retrying) return null;

  return (
    <div
      role="status"
      className="fixed top-0 inset-x-0 z-[9999] bg-amber-50 border-b border-amber-200 text-amber-900 text-xs flex items-center justify-center gap-2 px-4 py-1.5"
      data-testid="api-status-banner"
    >
      <Loader2 size={12} className="animate-spin" />
      <span>Reconnecting to ROC Vault — the server is warming up…</span>
    </div>
  );
}
